import Icon from 'snippets/icon/icon'

/**
 * @param {{type: string, name: string, value: boolean, onChange: (e: JSXInternal.TargetedEvent<HTMLInputElement, Event>) => void, label: string, required?: boolean}} props
 */
export const FieldBasicCheckbox = (props) => {
  const isChecked = props.value
  return (
    <div className={'my-auto flex flex-row items-center gap-4 py-2'}>
      <div className={'relative h-8 w-8 cursor-pointer border border-solid border-black'}>
        <input
          type="checkbox"
          className={'absolute inset-0 h-full w-full appearance-none opacity-0'}
          name={props.name}
          checked={isChecked}
          onChange={props.onChange}
        />
        {isChecked && (
          <div
            className={
              'pointer-events-none absolute m-auto flex h-full w-full flex-row items-center justify-center bg-black'
            }
          >
            <Icon id="tick" className="min-h-6 min-w-6 text-primary-white" />
          </div>
        )}
      </div>
      <div className={`paragraph-sm transition-opacity ${isChecked ? 'opacity-100' : 'opacity-60'}`}>
        {props.label}
        {props.required && '*'}{' '}
      </div>
    </div>
  )
}
